import { MutableRefObject, PropsWithChildren, createContext, useMemo, useState } from 'react';
import { UploadFile, UploadRef } from 'components/upload/types';

interface IUploadContext {
    ref: MutableRefObject<UploadRef | null> | null;
    setRef: (ref: MutableRefObject<UploadRef | null> | null) => void;
    files: UploadFile[];
    setFiles: (files: UploadFile[]) => void;
}

const UploadContext = createContext<IUploadContext>({
    ref: null,
    setRef: () => {},
    files: [],
    setFiles: () => {},
});

const UploadProvider = (props: PropsWithChildren) => {
    const [ref, setRef] = useState<IUploadContext['ref']>(null);
    const [files, setFiles] = useState<any[]>([]);

    const ctx = useMemo(
        () => ({
            ref,
            files,
            setRef,
            setFiles,
        }),
        [files, ref],
    );

    return <UploadContext.Provider value={ctx}>{props.children}</UploadContext.Provider>;
};

export { UploadContext, UploadProvider };
export type { IUploadContext };
